<template>
<span>
  <span v-if="lookingForProperty">
    Looks for a property named <span class="has-text-danger">${{ payload.identifier.name }}</span>
    and extracts <span class="has-text-danger">{{ payload.extracts.type }}</span>
  </span>
  <span v-if="lookingForMethodCall">
    Looks for a method call <span class="has-text-danger">->{{ payload.identifier.name }}()</span>
    and if found extracts the <span class="has-text-danger">{{ payload.extracts.type }}</span>
    from where it is called
  </span>
</span>
</template>
<script>
export default {
  
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    type() {
      return this.payload.type
    },
    lookingForProperty() {
      return this.type === 'property'
    },
    lookingForMethodCall() {
      return this.type === 'method_call'
    }
  }

}
</script>